/** Mermaid diagrams for Inngest background jobs. */

export const INNGEST_BRIDGE_CHART = `
flowchart LR
  subgraph callers["Who sends events"]
    EDGE["Edge functions<br/>materialize-newsletter · request-send…"]
    MAN["Manual / Inngest dashboard<br/>replay or ad-hoc"]
  end

  subgraph cloud["Inngest Cloud"]
    Q["Event queue + cron scheduler"]
  end

  subgraph supa["Supabase Edge"]
    FN["/functions/v1/inngest<br/>serve() — 7 registered workers"]
    DB[("Postgres via<br/>service role")]
  end

  EDGE -->|inngest.send| Q
  MAN --> Q
  Q -->|signed HTTP| FN
  FN --> DB
`;

export const INNGEST_EMAIL_FLOW_CHART = `
flowchart TB
  MAT["materialize-newsletter"] -->|personalize.requested| PERS["personalize-scheduled-emails<br/>every 15 min"]
  PERS --> ROW[("scheduled_emails<br/>pending + personalized")]
  CRON["process-scheduled-emails<br/>every 5 min"] --> ROW
  NOW["send-scheduled-email-now<br/>Send now button"] --> ROW
  ROW --> PM["Postmark send"]
  CRON2["publish-completed-newsletters<br/>every 5 min"] --> PUB["newsletter → Published"]
  PM --> CRON2
  SUB["subscriber/created"] --> WEL["welcome-email"]
  WEL --> ROW
  PM --> EVT[("email_engagement_events")]
  ROLL["rollup-email-engagement<br/>daily 6:00 UTC"] --> EVT
`;
